<!--
Author: TangChen
Date: 2018-10-15
Desc: 开户表单页面，为公共组件
 -->
<template>
    <div class="comp-open-acct comp">
        <!-- 证件开户填写信息 -->
        <el-form
            ref="acctInfo"
            :model="acctInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm open-box"
            inline-message
            v-on:submit.native.prevent
        >
            <div class="cut-off-line top">
                <span>设置交易密码</span>
            </div>
            <el-form-item label="设置交易密码：" prop="pwd" class="required">
                <el-input
                    v-model.trim="acctInfo.pwd"
                    :type="pwdType"
                    placeholder="请设置交易密码"
                    :maxlength="16"
                >
                    <i
                        slot="suffix"
                        :class="iconCla"
                        aria-hidden="true"
                        v-on:click="pwdTypeChange"
                    />
                </el-input>
            </el-form-item>
            <el-form-item class="pwd-text">
                <div class="info" v-text="pwdText"></div>
            </el-form-item>
            <el-form-item label="再次输入交易密码：" prop="pwdConfirm" class="required">
                <el-input
                    v-model.trim="acctInfo.pwdConfirm"
                    :type="pwdType"
                    placeholder="请再次输入交易密码"
                    :maxlength="16"
                >
                    <i
                        slot="suffix"
                        :class="iconCla"
                        aria-hidden="true"
                        v-on:click="pwdTypeChange"
                    />
                </el-input>
            </el-form-item>
            <div class="cut-off-line">
                <span>完善信息</span>
            </div>
            <el-form-item label="国籍：" prop="country" class="required">
                <el-select v-model.trim="acctInfo.country" placeholder="请选择国籍">
                    <el-option
                        v-for="item in country"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.country == 'CN'"
                label="省份："
                prop="otherprovince"
                class="required"
            >
                <el-select v-model.trim="acctInfo.otherprovince" placeholder="请选择省份">
                    <el-option
                        v-for="item in province"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="data.certType !== '0'"
                class="radio-list required"
                label="性别："
                prop="sex"
            >
                <el-radio-group v-model="acctInfo.sex">
                    <el-radio v-for="item in sex" :key="item.subitem" :label="item.subitem">
                        {{ item.subitemname }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                v-if="data.isBranch === '1'"
                label="开户行所在省："
                prop="bankprovince"
                class="required"
            >
                <el-select
                    v-model="acctInfo.bankprovince"
                    filterable
                    placeholder="请选择开户行所在省"
                >
                    <el-option
                        v-for="item in bankprovince"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="data.isBranch === '1' && acctInfo.bankprovince !== ''"
                label="开户行所在城市："
                prop="city"
                class="required"
            >
                <el-select v-model="acctInfo.city" filterable placeholder="请选择开户行所在城市">
                    <el-option
                        v-for="item in city"
                        :key="item.cityid"
                        :label="item.cityname"
                        :value="item.cityid"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="data.isBranch === '1' && acctInfo.city !== ''"
                label="开户行名称："
                prop="bankname"
                class="required"
            >
                <el-autocomplete
                    ref="autocomplete"
                    v-model.trim="acctInfo.bankname"
                    class="inline-input"
                    :fetch-suggestions="querySearch"
                    popper-class="auto-width-select-option"
                    placeholder="请输入开户行名称"
                    :maxlength="40"
                    v-on:blur="checkBankName"
                    v-on:focus="clearOption"
                >
                    <el-tooltip
                        slot="suffix"
                        class="item"
                        effect="info"
                        :content="infoText"
                        placement="top"
                    >
                        <el-button class="info-btn">
                            <i class="el-icon-question" aria-hidden="true" />
                        </el-button>
                    </el-tooltip>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="职业：" prop="occupation" class="required">
                <el-select v-model.trim="acctInfo.occupation" filterable placeholder="请选择职业">
                    <el-option
                        v-for="item in occupation"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.occupation === 'V14' || acctInfo.occupation === 'V29'"
                label="职业补充信息："
                prop="vocationsupple"
                :class="{
                    required: acctInfo.occupation === 'V14' || acctInfo.occupation === 'V29'
                }"
            >
                <el-input
                    v-model.trim="acctInfo.vocationsupple"
                    placeholder="请输入职业补充信息"
                    :maxlength="22"
                />
            </el-form-item>
            <el-form-item class="required" label="对账单寄送周期：" prop="delivertype">
                <el-select v-model="acctInfo.delivertype" placeholder="请选择对账单寄送周期">
                    <el-option
                        v-for="item in delivertype"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                label="对账单寄送方式："
                prop="deliverway"
                :class="acctInfo.delivertype === '1' ? '' : 'required'"
            >
                <el-select
                    v-model="acctInfo.deliverway"
                    placeholder="请选择对账单寄送方式"
                    :disabled="acctInfo.delivertype === '1'"
                    multiple
                    maxlength="32"
                    clearable
                    v-on:change="getDeliverway"
                >
                    <el-option
                        v-for="item in deliverways"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.deliverway === '2' || acctInfo.deliverway === '5'"
                label="传真号码："
                prop="fax"
                class="required"
            >
                <el-select
                    v-model="acctInfo.faxcycode"
                    placeholder="请选择国家码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in faxcycode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-select
                    v-if="acctInfo.faxcycode == '86'"
                    v-model="acctInfo.faxareacode"
                    placeholder="请选择地区码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in faxareacode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-input
                    v-else
                    v-model.trim="acctInfo.faxareacodeinput"
                    placeholder="请输入地区码"
                    style="width: 150px !important"
                />
                <el-input
                    v-model.trim="acctInfo.fax"
                    placeholder="请输入传真号码"
                    :maxlength="11"
                    style="width: 300px"
                />
            </el-form-item>
            <el-form-item label="电话号码：" prop="telno" class="required">
                <el-select
                    v-model="acctInfo.telnocycode"
                    placeholder="请选择国家码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in faxcycode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-select
                    v-if="acctInfo.telnocycode == '86'"
                    v-model="acctInfo.telnoareacode"
                    placeholder="请选择地区码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in faxareacode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-input
                    v-else
                    v-model.trim="acctInfo.telnoareacodeinput"
                    placeholder="请输入地区码"
                    style="width: 150px !important"
                />
                <el-input
                    v-model.trim="acctInfo.telno"
                    placeholder="请输入电话号码"
                    :maxlength="11"
                    style="width: 300px"
                />
            </el-form-item>
            <!-- <el-form-item label="联系地址：" prop="selectedOptions" class="required">
                <el-cascader expandTrigger="hover" :options="options" v-model="acctInfo.selectedOptions" size="medium"></el-cascader>
            </el-form-item> -->
            <!-- <el-form-item prop="livingaddress" class="required">
                <el-input v-model.trim="acctInfo.livingaddress" placeholder="请输入详细地址具体到门牌号"
                          @click.native="showAddrTip = true"
                          @blur="showAddrTip = false"
                          :maxlength="64"/>
            </el-form-item>
            <el-form-item v-if="showAddrTip">
                <el-tag type="info">&nbsp;例：XX省XX市XX区XX社区XX单元XXXX室&nbsp;&nbsp;&nbsp;</el-tag>
            </el-form-item> -->
            <!--<el-form-item label="详细地址：" prop="address">
                <el-input v-model.trim="acctInfo.address" placeholder="请输入详细地址" :maxlength="64"/>
            </el-form-item>
            <el-form-item label="特定自然人标识：" prop="natural">
                <el-select v-model.trim="acctInfo.natural" filterable placeholder="请选择特定自然人标识">
                    <el-option
                        v-for="item in natural"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>-->
            <el-form-item label="邮政编码：" prop="postcode" class="required">
                <el-input
                    v-model.trim="acctInfo.postcode"
                    placeholder="请输入邮政编码"
                    :maxlength="6"
                />
            </el-form-item>
            <el-form-item label="邮箱：" prop="email" class="required">
                <el-input
                    v-model.trim="acctInfo.email"
                    placeholder="请输入电子邮箱"
                    :maxlength="64"
                />
            </el-form-item>

            <country-city-select
                ref="livingaddress"
                v-model="livingAddressObj"
                required
                country-layout="user"
                v-on:input="getAdrss"
            ></country-city-select>

            <el-form-item label="详细地址：" prop="address" class="required">
                <el-input
                    v-model.trim="acctInfo.address"
                    placeholder="请输入详细地址"
                    :maxlength="64"
                />
            </el-form-item>
            <el-form-item label="特定自然人标识：" prop="natural" class="required">
                <el-select
                    v-model.trim="acctInfo.natural"
                    filterable
                    placeholder="请选择特定自然人标识"
                >
                    <el-option
                        v-for="item in natural"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <!--<el-form-item label="受益人类型：" prop="isdigniaryorceo">-->
            <!--<el-select v-model.trim="acctInfo.isdigniaryorceo" filterable placeholder="请选择受益人类型">-->
            <!--<el-option-->
            <!--v-for="item in isdigniaryorceo"-->
            <!--:key="item.subitem"-->
            <!--:label="item.subitemname"-->
            <!--:value="item.subitem"-->
            <!--/>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item
                v-if="
                    !$util.isEmpty(acctInfo.natural) &&
                    acctInfo.natural !== '0' &&
                    acctInfo.natural !== 'A'
                "
                prop="assetssource"
                label="财产和资金来源："
                :class="{ required: acctInfo.natural !== '0' && acctInfo.natural !== 'A' }"
            >
                <el-input
                    v-model.trim="acctInfo.assetssource"
                    placeholder="请输入财产和资金来源"
                    :maxlength="64"
                />
            </el-form-item>
            <el-form-item label="学历：" prop="educationlevel" class="required">
                <el-select
                    v-model.trim="acctInfo.educationlevel"
                    filterable
                    placeholder="请选择学历"
                >
                    <el-option
                        v-for="item in educationlevel"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>

            <!--235-->
            <el-form-item label="受益人类型：" prop="benefisself" class="required">
                <el-select v-model.trim="acctInfo.benefisself" placeholder="请选择受益人类型">
                    <el-option
                        v-for="item in benefisself"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item class="pwd-text">
                <div class="info">
                    基金账户/交易账户项下基金交易的实际受益人。如实际受益人为本人，请选择本人；如实际受益人为他人，请根据系统提示填写相关信息。
                </div>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人姓名："
                prop="beneficiary"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.beneficiary"
                    placeholder="请输入受益人姓名"
                    :maxlength="20"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="实际受益人证件类型："
                prop="beneficiarytype"
                class="required"
            >
                <el-select
                    v-model.trim="acctInfo.beneficiarytype"
                    placeholder="请选择受益人证件类型"
                >
                    <el-option
                        v-for="item in beneficiarytype"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="实际受益人证件号码："
                prop="beneficiaryno"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.beneficiaryno"
                    placeholder="请输入受益人证件号码"
                    :maxlength="32"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="实际受益人证件有效期："
                prop="beneficiarydate"
                class="required"
            >
                <date-picker
                    :date="dateSet"
                    v-on:date-get="beneficiaryDateInterval"
                    v-on:validGet="dealValid_benefit"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人性别："
                prop="beneficiarysex"
                class="required"
            >
                <el-radio-group v-model="acctInfo.beneficiarysex">
                    <el-radio
                        v-for="item in beneficiarysex"
                        :key="item.subitem"
                        :label="item.subitem"
                    >
                        {{ item.subitemname }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人出生日期："
                prop="beneficiarybirthday"
                class="birthdate-select required"
            >
                <date-picker :date="dateBenefSetBirth" v-on:date-get="dateInterval_birth" />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人职业："
                prop="beneficiaryvocation"
                class="required"
            >
                <el-select
                    v-model.trim="acctInfo.beneficiaryvocation"
                    filterable
                    placeholder="请选择职业"
                >
                    <el-option
                        v-for="item in occupation"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人电话号码："
                prop="beneficiarytelno"
                class="required"
            >
                <el-select
                    v-model="acctInfo.beneficiarytelnocycode"
                    placeholder="请选择国家码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in cncountrycode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-select
                    v-if="acctInfo.beneficiarytelnocycode == '86'"
                    v-model="acctInfo.beneficiarytelnoareacode"
                    placeholder="请选择地区码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in faxareacode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-input
                    v-else
                    v-model.trim="acctInfo.beneficiarytelnoareacodeinput"
                    placeholder="请输入地区码"
                    style="width: 150px !important"
                />
                <el-input
                    v-model.trim="acctInfo.beneficiarytelno"
                    style="margin-left: 2px; width: 300px"
                    placeholder="请输入电话号码"
                    :maxlength="11"
                />
            </el-form-item>

            <div v-if="acctInfo.benefisself === '0'">
                <country-city-select
                    ref="livingaddress"
                    v-model="benefAddressObj"
                    required
                    country-layout="user"
                    v-on:input="getBenefAdrss"
                ></country-city-select>
            </div>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人详细地址："
                prop="beneficiaryaddr"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.beneficiaryaddr"
                    placeholder="请输入受益人详细地址"
                    :maxlength="64"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人邮箱："
                prop="beneficiaryemail"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.beneficiaryemail"
                    placeholder="请输入电子邮箱"
                    :maxlength="64"
                />
            </el-form-item>

            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人邮政编码："
                prop="beneficiarypostcode"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.beneficiarypostcode"
                    placeholder="请输入邮政编码"
                    :maxlength="6"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.benefisself === '0'"
                label="受益人与持有人关系："
                prop="benefrelation"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.benefrelation"
                    placeholder="请输入受益人与持有人关系"
                />
            </el-form-item>

            <!-- 控制人开始 -->
            <el-form-item label="控制人类型：" prop="actualisself" class="required">
                <el-select v-model.trim="acctInfo.actualisself" placeholder="请选择控制人类型">
                    <el-option
                        v-for="item in actualisself"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item class="pwd-text">
                <div class="info">
                    指实际控制客户的自然人。如无控制人，请选择本人，如存在控制人，请根据系统提示填写相关信息。
                </div>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人姓名："
                prop="actualctrlname"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.actualctrlname"
                    placeholder="请输入控制人姓名"
                    :maxlength="20"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="实际控制人证件类型："
                prop="actualctrlidtype"
                class="required"
            >
                <el-select
                    v-model.trim="acctInfo.actualctrlidtype"
                    placeholder="请选择控制人证件类型"
                >
                    <el-option
                        v-for="item in actualctrlidtype"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="实际控制人证件号码："
                prop="actualctrlidcode"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.actualctrlidcode"
                    placeholder="请输入控制人证件号码"
                    :maxlength="32"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="实际控制人证件有效期："
                prop="actualctrlvalidate"
                class="required"
            >
                <date-picker
                    :date="dateSet"
                    v-on:date-get="actualctrlDateInterval"
                    v-on:validGet="dealValid_actual"
                />
            </el-form-item>
            <!-- start -->
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人性别："
                prop="actualctrlsex"
                class="required"
            >
                <el-radio-group v-model="acctInfo.actualctrlsex">
                    <el-radio
                        v-for="item in actualctrlsex"
                        :key="item.subitem"
                        :label="item.subitem"
                    >
                        {{ item.subitemname }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人出生日期："
                prop="actualctrlbirthday"
                class="birthdate-select required"
            >
                <date-picker :date="dateSetBirth" v-on:date-get="dateInterval_birth2" />
                <!-- <date-picker :date="dateSet" v-on:date-get="dateInterval" /> -->
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人职业："
                prop="actualctrlvocation"
                class="required"
            >
                <el-select
                    v-model.trim="acctInfo.actualctrlvocation"
                    filterable
                    placeholder="请选择职业"
                >
                    <el-option
                        v-for="item in actualctrlvocation"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人电话号码："
                prop="actualctrltelno"
                class="required"
            >
                <el-select
                    v-model="acctInfo.actualctrltelnocycode"
                    placeholder="请选择国家码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in actualctrltelnocycode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-select
                    v-if="acctInfo.actualctrltelnocycode == '86'"
                    v-model="acctInfo.actualctrltelnoareacode"
                    placeholder="请选择地区码"
                    style="width: 150px !important"
                >
                    <el-option
                        v-for="item in faxareacode"
                        :key="item.subitem"
                        :label="item.subitemname + ' ' + item.subitem"
                        :value="item.subitem"
                    >
                        <div>{{ item.subitemname + " " + item.subitem }}</div>
                    </el-option>
                </el-select>
                <el-input
                    v-else
                    v-model.trim="acctInfo.actualctrltelnoareacodeinput"
                    placeholder="请输入地区码"
                    style="width: 150px !important"
                />
                <el-input
                    v-model.trim="acctInfo.actualctrltelno"
                    style="margin-left: 2px; width: 300px"
                    placeholder="请输入电话号码"
                    :maxlength="11"
                />
            </el-form-item>

            <div v-if="acctInfo.actualisself === '0'">
                <country-city-select
                    ref="livingaddress"
                    v-model="actualAddressObj"
                    required
                    country-layout="user"
                    v-on:input="getActualAdrss"
                ></country-city-select>
            </div>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人详细地址："
                prop="actualctrladdr"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.actualctrladdr"
                    placeholder="请输入控制人详细地址"
                    :maxlength="64"
                />
            </el-form-item>

            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人邮箱："
                prop="actualctrlemail"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.actualctrlemail"
                    placeholder="请输入电子邮箱"
                    :maxlength="64"
                />
            </el-form-item>

            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人邮政编码："
                prop="actualctrlpostcode"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.actualctrlpostcode"
                    placeholder="请输入邮政编码"
                    :maxlength="6"
                />
            </el-form-item>
            <el-form-item
                v-if="acctInfo.actualisself === '0'"
                label="控制人与持有人关系："
                prop="actualrelation"
                class="required"
            >
                <el-input
                    v-model.trim="acctInfo.actualrelation"
                    placeholder="请输入控制人与持有人关系"
                />
            </el-form-item>
            <!-- 控制人结束 -->
            <el-form-item>
                <agreement v-model="protocol" :data="agrType" v-on:all-read="agreePro"></agreement>
            </el-form-item>
            <el-form-item>
                <div style="width: 50%">
                    <el-button type="primary" class="medium" v-on:click.prevent="submitInfo()">
                        下一步
                    </el-button>
                    <el-button class="medium" v-on:click="backPage">返回</el-button>
                </div>
            </el-form-item>
        </el-form>
        <!--<el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <el-checkbox v-model="checked" class="check-style">
            </el-checkbox>
            <span>本人保证提供的信息真实、准确、完整，知晓并确认若提供的信息不真实、不准确、不完整的，应该依法承担相应的法律责任，兴华基金将不承担由此导致的关于适当性不匹配的任何后果，且有权拒绝销售产品或提供服务。本人已知晓并确认提供信息发生重要变化、可能影响投资者分类的，应当及时更新并告知兴华基金。</span>
            <span slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="!checked" v-on:click="gotoSub()">确 定</el-button>
            </span>
        </el-dialog>-->
    </div>
</template>
<script>
import agreement from "@/components/form/agreement.vue";
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";
import countryCitySelect from "@/components/acct/countryCitySelect.vue";
import { sceneEnum } from "@/util/util_jfit";
export default {
    name: "Tab",
    components: {
        agreement,
        datePicker,
        countryCitySelect
    },
    props: {
        data: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            livingAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            benefAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            actualAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            dateSetBirth: { type: "1", max: "", dis: false, val: "", text: "请选择出生日期" },
            dateBenefSetBirth: { type: "1", max: "", dis: false, val: "", text: "请选择出生日期" },
            province: [], // 省
            bankprovince: [], // 省
            city: [], // 城市
            country: [],
            delivertype: [], // 对账单寄送类型
            deliverways: [], // 对账单寄送类型
            beneficiarytype: [],
            benefisself: [],
            sex: [], // 性别
            pwdType: "password",
            agrType: sceneEnum.open, // 协议类型，开户协议
            iconCla: "fa fa-eye-slash",
            natural: [],
            isdigniaryorceo: [],
            cncountrycode: [],
            beneficiarysex: [],
            beneficiaryvocation: [], // 受益人职业
            assetssource: "", // 资金来源
            beneficiaryaddrcity: [], // 受益人城市
            beneficiaryaddrcounty: [], // 受益人县
            addresscity: [],
            addresscounty: [],
            faxareacode: [],
            actualisself: [], // 控制人
            actualctrlvocation: [],
            actualctrltelnocycode: [],
            actualctrlsex: [],
            actualctrlidtype: [],
            actualctrlcountry: [],
            actualctrladdrprovince: [],
            actualctrladdrcounty: [],
            actualctrladdrcity: [],
            faxcycode: [],
            // faxareacode:[],
            acctInfo: {
                // 交易账户信息
                pwd: "",
                pwdConfirm: "",
                loginpwd: "",
                loginPwdConfirm: "",
                delivertype: "",
                deliverway: "",
                // deliverwayText: '',
                email: "",
                faxcycode: "86",
                faxareacode: "",
                fax: "",
                faxareacodeinput: "",
                telnocycode: "86",
                telno: "",
                telnoareacode: "",
                telnoareacodeinput: "",
                address: "",
                postcode: "",
                country: "CN",
                otherprovince: "",
                province: "",
                livingcountry: "", // 国家
                bankprovince: "",
                city: "",
                sex: "",
                // sexText: '',
                bankname: "",
                branchcode: "",
                benefisself: "",
                beneficiary: "",
                beneficiarytype: "",
                beneficiaryno: "",
                beneficiarydate: "",
                // assetssource: "",
                // actualctrlvalidate:"",
                // assetssource: "",
                //                    income:'',
                cnprovince: "",
                cncity: "",
                county: "", // 县
                cncountry: "",
                natural: "",
                isdigniaryorceo: "",
                cncountrycode: "中国+86",
                mobile: "",
                assetssource: "", // 资金来源
                beneficiarycountry: "", // 受益人国家
                beneficiaryaddrprovince: "", // 受益人省份
                beneficiaryaddrcity: "", // 受pack益人城市
                beneficiaryaddrcounty: "", // 受益人县
                beneficiaryemail: "", // 受益人邮箱
                beneficiarypostcode: "", // 受益人邮箱编码
                beneficiarysex: "", // 受益人性别
                beneficiaryvocation: "", // 受益人职业
                beneficiarytelnocycode: "86", // 国家码
                beneficiarytelnoareacode: "",
                beneficiarytelnoareacodeinput: "",
                beneficiarytelno: "", // 手机号
                beneficiaryaddr: "", // 受益人详细地址
                addressprovince: "",
                addresscity: "",
                addresscounty: "",
                beneficiarybirthday: "", // 受益人出生日期
                benefrelation: "",
                cnprovice: "",
                // addresscounty:'',
                occupation: "",
                // faxareacode:'',
                // fax:'',
                actualisself: "", // 控制人
                actualctrlvocation: "",
                actualctrltelnocycode: "86",
                actualctrltelnoareacode: "",
                actualctrltelnoareacodeinput: "",
                actualctrlsex: "",
                actualctrlidtype: "",
                actualctrlcountry: "",
                actualctrladdrprovince: "",
                actualctrladdr: "",
                actualctrladdrcity: "",
                actualctrladdrcounty: "",
                actualctrlbirthday: "",
                actualctrlemail: "",
                actualctrlidcode: "",
                actualctrlname: "",
                actualctrlpostcode: "",
                actualctrltelno: "",
                actualctrlvalidate: "",
                actualrelation: "",
                actualctrlvalitype: "", // 实际控制人有效类型
                benefitvalidtype: "" // 实际受益人有效类型
            },
            dateSet: { type: "3", max: "", val: "", text: "请选择证件有效期" },
            protocol: false,
            occupation: [],
            vocationcode: [],
            educationlevel: [],
            // assetssource: [],
            infoText: "如果下拉选项中及搜索结果中没有您的开户行，请选择附近的开户行",
            query: null, // 定时查找
            branchList: [], // 支行列表
            rules: {
                // 校验规则
                pwd: [
                    { validator: this.$util.validateTPwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ],
                pwdConfirm: [
                    { validator: this.$util.validateTPwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ],
                otherprovince: [{ required: true, message: "请选择省份", trigger: "change" }],
                natural: [{ required: true, message: "请选择特定自然人标识", trigger: "change" }],
                educationlevel: [{ required: true, message: "请选择学历", trigger: "change" }],
                isdigniaryorceo: [
                    { required: true, message: "请选择受益人类型", trigger: "change" }
                ],
                sex: [{ required: true, message: "请选择性别", trigger: "change" }],
                delivertype: [
                    { required: true, message: "请选择对账单寄送周期", trigger: "change" }
                ],
                occupation: [{ required: true, message: "请选择职业", trigger: "change" }],
                deliverway: [{ validator: this.validateDeliverway, trigger: "change" }],
                address: [{ required: true, validator: this.validateAddress, trigger: "blur" }],
                bankprovince: [{ required: true, message: "请选择开户省", trigger: "change" }],
                city: [{ required: true, message: "请选择开户城市", trigger: "change" }],
                benefisself: [{ required: true, message: "请选择受益人类型", trigger: "change" }],
                beneficiary: [{ validator: this.validateBeneficiary, trigger: "blur" }],
                beneficiarytype: [{ validator: this.validateBeneficiarytype, trigger: "change" }],
                beneficiaryno: [{ validator: this.validateBeneficiaryno, trigger: "blur" }],
                beneficiarydate: [{ validator: this.validateBeneficiarydate, trigger: "blur" }],
                beneficiarytelno: [
                    { required: true, message: "请输入电话号码", trigger: "blur" },
                    { validator: this.$util.validateFaxNum, trigger: "blur" }
                ],
                beneficiarybirthday: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                beneficiarysex: [{ required: true, message: "请选择性别", trigger: "change" }],
                beneficiaryvocation: [{ required: true, message: "请选择职业", trigger: "change" }],
                beneficiaryemail: [{ validator: this.$util.validateEmail, trigger: "blur" }],
                beneficiarypostcode: [{ validator: this.$util.validatePostCode, trigger: "blur" }],
                beneficiaryaddr: [{ validator: this.validateBeneficiaryaddr, trigger: "blur" }],
                benefrelation: [
                    { required: true, message: "请输入受益人与持有人关系", trigger: "blur" }
                ],
                actualisself: [{ required: true, message: "请选择控制人类型", trigger: "change" }],
                actualctrlname: [{ validator: this.validateActualctrlname, trigger: "blur" }],
                actualctrlsex: [{ required: true, message: "请选择性别", trigger: "change" }],
                actualctrlidtype: [{ validator: this.validateActualctrlidtype, trigger: "change" }],
                actualctrlidcode: [{ validator: this.validateActualctrl, trigger: "blur" }],
                actualctrlbirthday: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrlvalidate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrltelno: [
                    { required: true, message: "请输入电话号码", trigger: "blur" },
                    { validator: this.$util.validateFaxNum, trigger: "blur" }
                ],
                actualctrlvocation: [{ required: true, message: "请选择职业", trigger: "change" }],
                actualctrlpostcode: [{ validator: this.validatePostCode2, trigger: "blur" }],
                actualctrlemail: [{ validator: this.$util.validateEmail, trigger: "blur" }],
                actualctrladdr: [
                    { required: true, validator: this.validateActualctrladdr, trigger: "blur" }
                ],
                actualrelation: [
                    { required: true, message: "请输入控制人与持有人关系", trigger: "blur" }
                ],
                /* selectedOptions: [
                    { validator: this.validateSelectedOptions, trigger: "change" }
                ], */
                livingaddress: [{ validator: this.validateLivingaddress, trigger: "blur" }],
                assetssource: [{ validator: this.validateAssetssource, trigger: "blur" }],
                province: [{ validator: this.validateLocation, trigger: "change" }],
                bankname: [
                    { required: true, message: "请选择开户行名称", trigger: "change" },
                    { validator: this.$util.validateBankName, trigger: "change" }
                ],
                vocationsupple: [
                    { required: true, validator: this.validateVocationsupple, trigger: "blur" }
                ],
                postcode: [
                    { required: true, message: "请输入邮政编码", trigger: "blur" },
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                email: [
                    { required: true, message: "请输入电子邮箱", trigger: "blur" },
                    { validator: this.$util.validateEmail, trigger: "blur" }
                ],
                telno: [{ validator: this.$util.validateFaxNum, trigger: "blur" }]
            },
            options: [],
            showAddrTip: false,
            // dialogVisible: false,
            checked: false,
            pwdText: ""
        };
    },
    watch: {
        "acctInfo.delivertype"(val) {
            if (val === "1") {
                this.acctInfo.deliverway = "";
            }
        },
        "acctInfo.country"(val) {
            this.acctInfo.otherprovince = "";
        },
        "acctInfo.occupation"(val) {
            if (val !== "V14" && val !== "V29") {
                this.acctInfo.vocationsupple = "";
            }
        },
        "acctInfo.bankprovince"(val) {
            const _this = this;
            // 城市查询
            const _p = _this.bankprovince.find((item) => {
                return item.subitem === val;
            });
            this.$util.getCity(_p.subitem, (data) => {
                _this.city = data || [];
                if (!this.acctInfo.city || !this.matched()) {
                    _this.$set(_this.acctInfo, "city", _this.city[0].cityid || "");
                }
            });
        },
        "acctInfo.city"() {
            this.acctInfo.bankname = "";
            this.clearOption();
        },
        // "acctInfo.isdigniaryorceo" (val) {
        //     if(val === '0'){
        //         this.acctInfo.assetssource = "";
        //     }else {
        //         this.acctInfo.assetssource = this.assetssource[0]["subitemname"];
        //     }
        // },
        "acctInfo.benefisself"(val) {
            this.acctInfo.beneficiary = "";
            this.acctInfo.beneficiarytype = "";
            this.acctInfo.beneficiaryno = "";
            this.acctInfo.beneficiarydate = "";
            this.acctInfo.beneficiarysex = "";
            this.acctInfo.beneficiarybirthday = "";
            this.acctInfo.beneficiaryvocation = "";
            this.acctInfo.beneficiarytelnocycode = "";
            this.acctInfo.beneficiarytelnoareacode = "";
            this.acctInfo.beneficiarytelnoareacodeinput = "";
            this.acctInfo.beneficiarytelno = "";
            this.acctInfo.beneficiarycountry = "";
            this.acctInfo.beneficiaryaddrprovince = "";
            this.acctInfo.beneficiaryaddrcity = "";
            this.acctInfo.beneficiaryaddrcounty = "";
            this.acctInfo.beneficiaryaddr = "";
            this.acctInfo.beneficiaryemail = "";
            this.acctInfo.beneficiarypostcode = "";
            this.acctInfo.benefrelation = "";
            if (val === "0") {
                this.acctInfo.beneficiarytelnocycode = "86";
            }
        },
        "acctInfo.actualisself"(val) {
            this.acctInfo.actualctrl = "";
            this.acctInfo.actualctrltype = "";
            this.acctInfo.actualctrlno = "";
            this.acctInfo.actualctrldate = "";
            this.acctInfo.actualctrlsex = "";
            this.acctInfo.actualctrlbirthday = "";
            this.acctInfo.actualctrlvocation = "";
            this.acctInfo.actualctrltelnocycode = "";
            this.acctInfo.actualctrltelnoareacode = "";
            this.acctInfo.actualctrltelnoareacodeinput = "";
            this.acctInfo.actualctrltelno = "";
            this.acctInfo.actualctrlcountry = "";
            this.acctInfo.actualctrladdrprovince = "";
            this.acctInfo.actualctrladdrcity = "";
            this.acctInfo.actualctrladdrcounty = "";
            this.acctInfo.actualctrladdr = "";
            this.acctInfo.actualctrlemail = "";
            this.acctInfo.actualctrlpostcode = "";
            this.acctInfo.actualrelation = "";
            if (val === "0") {
                this.acctInfo.actualctrltelnocycode = "86";
            }
        },
        "acctInfo.telnocycode"(val) {
            this.acctInfo.telnoareacode = "";
            this.acctInfo.telnoareacodeinput = "";
        },
        "acctInfo.telnoareacodeinput"(val) {
            this.acctInfo.telnoareacode = this.acctInfo.telnoareacodeinput;
        },
        "acctInfo.faxcycode"(val) {
            this.acctInfo.faxareacode = "";
            this.acctInfo.faxareacodeinput = "";
        },
        "acctInfo.faxareacodeinput"(val) {
            this.acctInfo.faxareacode = this.acctInfo.faxareacodeinput;
        },
        // "acctInfo.faxcycode"(val){
        //     if(val != "86"){
        //         this.acctInfo.faxareacode = "";
        //     }
        // },
        "acctInfo.beneficiarytelnocycode"(val) {
            this.acctInfo.beneficiarytelnoareacode = "";
            this.acctInfo.beneficiarytelnoareacodeinput = "";
        },
        "acctInfo.beneficiarytelnoareacodeinput"(val) {
            this.acctInfo.beneficiarytelnoareacode = this.acctInfo.beneficiarytelnoareacodeinput;
        },
        "acctInfo.actualctrltelnocycode"(val) {
            this.acctInfo.actualctrltelnoareacode = "";
            this.acctInfo.actualctrltelnoareacodeinput = "";
        },
        "acctInfo.actualctrltelnoareacodeinput"(val) {
            this.acctInfo.actualctrltelnoareacode = this.acctInfo.actualctrltelnoareacodeinput;
        }
        /* "acctInfo.selectedOptions":{
            handler(val){
                this.acctInfo.livingaddressprovince = val[0] || "";
                this.acctInfo.livingaddresscity = val[1] || "";
                this.acctInfo.livingaddresscounty = val[2] || "";
                if(val[0] === "710000" || val[0] === "810000" || val[0] === "820000"){
                    this.acctInfo.livingaddresscity = val[1] && val[1].substring(0,val[1].length - 1) || "";
                }
            },
            deep:true
        } */
    },
    mounted() {
        this.info = this.$cache.getUser();
        this.bankprovince = this.$cache.getDict("190021");
        this.country = this.$util.changeArrIndex(this.$cache.getDict("120109"), "CN");
        this.province = this.$cache.getDict("190021");
        this.delivertype = this.$cache.getDict("110046");
        this.deliverways = this.$cache.getDict("100013");
        // this.isdigniaryorceo = this.$cache.getDict("120126");
        // this.isdigniaryorceo = this.$cache.getDict("120179");
        // this.faxcycode = this.$cache.getDict("150136"); //国家码
        this.faxcycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.faxareacode = this.$cache.getDict("150137");
        this.benefisself = this.$cache.getDict("120137");
        this.beneficiarytype = this.$cache.getDict("130007");
        this.occupation = this.$cache.getDict("150141");
        this.vocationcode = this.$cache.getDict("100011");
        // this.cncountry = this.$cache.getDict("120109")
        // this.cnprovice = this.$cache.getDict("190021")
        this.natural = this.$cache.getDict("120200"); // 自然
        this.educationlevel = this.$cache.getDict("20011");
        this.isdigniaryorceo = this.$cache.getDict("120200");
        // this.cncountrycode = this.$cache.getDict("150136"); //国家码
        this.cncountrycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.beneficiarysex = this.$cache.getDict("110059"); // 受益人性别
        this.beneficiaryvocation = this.$cache.getDict("150141");
        this.faxareacode = this.$cache.getDict("150137");

        // 控制人
        this.actualisself = this.$cache.getDict("120137");
        this.actualctrlvocation = this.$cache.getDict("150141");
        // this.actualctrltelnocycode = this.$cache.getDict("150136"); //国家码
        this.actualctrltelnocycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.actualctrlsex = this.$cache.getDict("110059");
        this.actualctrlidtype = this.$cache.getDict("130007");
        this.actualctrlcountry = this.$cache.getDict("120109");
        this.actualctrladdrprovince = this.$cache.getDict("190021");
        const conf = this.$util.getConfig().const;
        this.assetssource = this.$cache.getDict("120073");
        this.assetssource.forEach((item) =>
            item.subitem === "4" ? (item.subitemname = "其他收入") : ""
        );
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.dateSetBirth.max = this.$util.fmtDate(birthmax);
        this.dateSetBirth.min = this.$util.fmtDate("19000101");
        this.$set(this.dateSet, "val", "");
        this.$set(this.dateSet, "time", new Date().getTime());
        this.dateBenefSetBirth.max = this.$util.fmtDate(birthmax);
        this.dateBenefSetBirth.min = this.$util.fmtDate("19000101");
        this.$set(this.dateBenefSetBirth, "val", "");
        this.$set(this.dateBenefSetBirth, "time", new Date().getTime());
        this.$set(this.dateSet, "val", "");
        this.$set(this.dateSet, "time", new Date().getTime());
        let _y = [];
        let _z = [];
        this.sex = this.$cache.getDict("110059").reverse();
        this.$cache.initCityCountyList();
        this.options = this.$util.initAddrCascaderOps();
        // this.initAddress();
        this.pwdText = this.$util.initTPwdCheckText();
        // 性别判断
        if (this.data.certType === "00" && this.data.certNo !== "") {
            let genderDigit = this.data.certNo.charAt(16);
            if (parseInt(genderDigit) % 2 === 0) {
                this.acctInfo.sex = "2";
            } else {
                this.acctInfo.sex = "1";
            }
        }
    },
    methods: {
        clearOption() {
            if (this.$refs.autocomplete) {
                this.$refs.autocomplete.suggestions = [];
            }
        },
        setLivingAddr() {
            // 现居国家、省、市、县
            this.acctInfo["cncountry"] = this.livingAddressObj["country"];
            this.acctInfo["cnprovince"] = this.livingAddressObj["province"];
            this.acctInfo["cncity"] = this.livingAddressObj["city"];
            this.acctInfo["cncounty"] = this.livingAddressObj["county"];
        },
        getAdrss(data) {
            this.acctInfo.address = data.address;
        },
        // 受益人国家、省、市、县
        setBenefAddress() {
            this.acctInfo["beneficiarycountry"] = this.benefAddressObj["country"];
            this.acctInfo["beneficiaryaddrprovince"] = this.benefAddressObj["province"];
            this.acctInfo["beneficiaryaddrcity"] = this.benefAddressObj["city"];
            this.acctInfo["beneficiaryaddrcounty"] = this.benefAddressObj["county"];
        },
        getBenefAdrss(data) {
            this.acctInfo.beneficiaryaddr = data.address;
        },
        // 控制人国家、省、市、县
        setActualAddress() {
            this.acctInfo["actualctrlcountry"] = this.actualAddressObj["country"];
            this.acctInfo["actualctrladdrprovince"] = this.actualAddressObj["province"];
            this.acctInfo["actualctrladdrcity"] = this.actualAddressObj["city"];
            this.acctInfo["actualctrladdrcounty"] = this.actualAddressObj["county"];
        },
        checkAddressInfo() {
            let hasLivingAddrInfo = true;
            if (this.acctInfo.cncountry === this.$const.CN) {
                hasLivingAddrInfo =
                    !!this.acctInfo.cnprovince && !!this.acctInfo.address && !!this.acctInfo.cncity;
            } else {
                hasLivingAddrInfo = !!this.acctInfo.address;
            }
            if (!hasLivingAddrInfo) {
                this.$alert("请完善现居地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        checkBenefActualInfo() {
            let hasBenefInfo = true;
            let hasCtrlInfo = true;
            if (this.acctInfo.benefisself === "0") {
                let excludeitems = ["county"]; // 有些地方没有县
                if (this.acctInfo.beneficiarycountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                }
                this.benefAddressObj.address = this.acctInfo.beneficiaryaddr;
                hasBenefInfo = this.$util.checkInfoFilled(this.benefAddressObj, excludeitems);
            }
            if (this.acctInfo.actualisself === "0") {
                let excludeitems = ["county"]; // 有些地方没有县
                if (this.acctInfo.actualctrlcountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                }
                this.actualAddressObj.address = this.acctInfo.actualctrladdr;
                hasCtrlInfo = this.$util.checkInfoFilled(this.actualAddressObj, excludeitems);
            }

            if (!hasCtrlInfo) {
                this.$alert("请完善实际控制人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            if (!hasBenefInfo) {
                this.$alert("请完善实际受益人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        getActualAdrss(data) {
            this.acctInfo.actualctrladdr = data.address;
        },
        dateInterval_birth(val) {
            this.acctInfo.beneficiarybirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        dateInterval_birth2(val) {
            this.acctInfo.actualctrlbirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        matched() {
            let match = false;
            this.city.forEach((item) => {
                if (item.cityid === this.acctInfo.city) {
                    match = true;
                }
            });
            return match;
        },
        initAddress(val) {
            let address = this.data.address;
            let provinceMatched = false;
            let cityMatched = false;
            let countyMatched = false;
            this.acctInfo.selectedOptions[0] = (val && val.value) || "";
            let _province = (this.acctInfo.bankprovince = (val && val.label) || "");
            try {
                this.options.forEach((province) => {
                    if ((provinceMatched || _province) && cityMatched && countyMatched) {
                        throw new Error("end loop");
                    }
                    if (address.indexOf(province.label) !== -1) {
                        this.acctInfo.selectedOptions[0] = province.value;
                        this.acctInfo.bankprovince = province.label;
                        _province = province.label;
                        address = address.substring(
                            address.lastIndexOf(province.label) + province.label.length
                        );
                        provinceMatched = true;
                    }
                    if (provinceMatched || val) {
                        province = val || province;
                        provinceMatched = !!val;
                        try {
                            province.children.forEach((city) => {
                                if (cityMatched && countyMatched) {
                                    throw new Error("end loop");
                                }
                                if (
                                    address.indexOf(city.label) !== -1 ||
                                    _province === city.label
                                ) {
                                    // 考虑直辖市情况（北京市平谷区）
                                    this.acctInfo.selectedOptions[1] = city.value;
                                    this.acctInfo.city = city.label;
                                    if (_province !== city.label) {
                                        address = address.substring(
                                            address.indexOf(city.label) + city.label.length
                                        );
                                    }
                                    cityMatched = true;
                                }
                                if (cityMatched) {
                                    try {
                                        city.children &&
                                            city.children.forEach((county, index) => {
                                                if (address.indexOf(county.label) !== -1) {
                                                    this.acctInfo.selectedOptions[2] = county.value;
                                                    address = address.substring(
                                                        address.indexOf(county.label) +
                                                            county.label.length
                                                    );
                                                    countyMatched = true;
                                                    throw new Error("end loop");
                                                }
                                                if (index === city.children.length - 1) {
                                                    // 身份证地址没有区默认取第一个
                                                    this.acctInfo.selectedOptions[2] =
                                                        city.children[0].value;
                                                    countyMatched = true;
                                                }
                                            });
                                    } catch (e) {
                                        this.$log.error(e);
                                    }
                                    this.acctInfo.livingaddress = address;
                                }
                            });
                        } catch (e) {
                            this.$log.error(e);
                        }
                        if (!cityMatched) {
                            // 没有市 #山东省（青岛市）平度市XXXX
                            try {
                                province.children.forEach((city) => {
                                    city.children &&
                                        city.children.forEach((county) => {
                                            if (address.indexOf(county.label) !== -1) {
                                                this.acctInfo.selectedOptions[1] = city.value;
                                                this.acctInfo.city = city.label;
                                                this.acctInfo.selectedOptions[2] = county.value;
                                                address = address.substring(
                                                    address.indexOf(county.label) +
                                                        county.label.length
                                                );
                                                cityMatched = true;
                                                countyMatched = true;
                                                throw new Error("end loop");
                                            }
                                        });
                                });
                            } catch (e) {
                                this.$log.error(e);
                            }
                            this.acctInfo.livingaddress = address;
                        }
                    }
                });
            } catch (e) {
                this.$log.error(e);
            }
            if (!provinceMatched) {
                // 身份证地址没有省份  广州市XXXX
                try {
                    this.options.forEach((province) => {
                        province.children.forEach((city) => {
                            if (address.indexOf(city.label) !== -1) {
                                this.initAddress(province);
                                throw new Error("end loop");
                            }
                        });
                    });
                } catch (e) {
                    this.$log.error(e);
                }
            }
        },
        setAddress() {
            this.options.forEach((province) => {
                if (province.value === this.acctInfo.selectedOptions[0]) {
                    this.acctInfo.address = province.label;
                    try {
                        province.children.forEach((city) => {
                            if (city.value === this.acctInfo.selectedOptions[1]) {
                                this.acctInfo.address += city.label;
                                city.children &&
                                    city.children.forEach((county) => {
                                        if (county.value === this.acctInfo.selectedOptions[2]) {
                                            this.acctInfo.address += county.label;
                                            throw new Error("end loop");
                                        }
                                    });
                                throw new Error("end loop");
                            }
                        });
                    } catch (e) {
                        this.$log.error(e);
                    }
                }
            });
            this.acctInfo.address += this.acctInfo.livingaddress;
        },
        validateEmail(rule, value, callback) {
            if (this.acctInfo.deliverway === "3" || value !== "") {
                this.$util.validateEmail(rule, value, callback);
            } else {
                callback();
            }
        },
        validateVocationsupple(rule, value, callback) {
            if (
                (this.acctInfo.occupation === "V14" || this.acctInfo.occupation === "V29") &&
                !value
            ) {
                callback(new Error("请输入职业补充信息"));
            } else {
                callback();
            }
        },
        /* 确认密码校验 */
        confirm(rule, value, callback) {
            if (
                this.acctInfo.pwd !== this.acctInfo.pwdConfirm &&
                this.acctInfo.pwd !== "" &&
                this.acctInfo.pwdConfirm !== ""
            ) {
                callback(new Error("输入密码和确认密码不一致"));
            } else {
                callback();
            }
        },
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            // 获取联行号
            const _y = this.branchList.filter((branch) => {
                return branch.branchname === this.acctInfo.bankname;
            });
            if (_y && _y[0]) {
                this.acctInfo.branchcode = _y[0].exchangecode;
            }
            /* if (this.acctInfo.deliverway === "1") {
                this.acctInfo.email = "";
            } else if (this.acctInfo.deliverway === "3") {
                this.acctInfo.address = "";
                this.acctInfo.postcode = "";
            } */
            this.acctInfo.location =
                this.acctInfo.cncountry === "CN"
                    ? this.$cache.getDict("190021", this.acctInfo.cnprovince)
                    : this.$cache.getDict("120109", this.acctInfo.cncountry);
            this.acctInfo.belongregion = this.acctInfo.cncountry === "CN" ? "中国" : "外国";
            this.acctInfo.isdigniaryorceo = this.acctInfo.natural;
            const _x = Object.assign({}, this.acctInfo);
            let string = _x.deliverway instanceof Array ? _x.deliverway.join(",") : "";
            _x.deliverway = string;
            this.$emit("get-acct", _x);
        },
        validateLocation(rule, value, callback) {
            if (this.acctInfo.country === "CN") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择省份"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateAssetssource(rule, value, callback) {
            if (
                this.acctInfo.natural === "1" ||
                this.acctInfo.natural === "2" ||
                this.acctInfo.natural === "3" ||
                this.acctInfo.natural === "4"
            ) {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入收入来源"));
                }
            }
            if (!this.$util.isEmpty(value)) {
                this.$util.validateGeneral(rule, value, callback, "收入来源");
            } else {
                callback();
            }
        },
        validateBeneficiary(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiarytype(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiaryno(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人证件号码"));
                } else {
                    this.$util.validateCertNo(rule, value, callback, this.acctInfo.beneficiarytype);
                }
            } else {
                callback();
            }
        },
        validateBeneficiarydate(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件有效期"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateAddress(rule, value, callback) {
            if (!value) {
                callback(new Error("请输入联系地址"));
                return;
            }
            let len = 0;
            for (let i = 0; i < value.length; i++) {
                if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
                    len += 2;
                } else {
                    len++;
                }
            }
            if (len < 12) {
                callback(new Error("详细地址不小于6个汉字或12个字符！"));
            } else {
                callback();
            }
        },
        validateBeneficiaryaddr(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (!value) {
                    callback(new Error("请输入受益人联系地址"));
                    return;
                }
                let len = 0;
                for (let i = 0; i < value.length; i++) {
                    if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
                        len += 2;
                    } else {
                        len++;
                    }
                }
                if (len < 12) {
                    callback(new Error("详细地址不小于6个汉字或12个字符！"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrladdr(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (!value) {
                    callback(new Error("请输入控制人联系地址"));
                    return;
                }
                let len = 0;
                for (let i = 0; i < value.length; i++) {
                    if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
                        len += 2;
                    } else {
                        len++;
                    }
                }
                if (len < 12) {
                    callback(new Error("详细地址不小于6个汉字或12个字符！"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlname(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlidtype(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择控制人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrl(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人证件号码"));
                } else {
                    this.$util.validateCertNo(
                        rule,
                        value,
                        callback,
                        this.acctInfo.actualctrlidtype
                    );
                }
            } else {
                callback();
            }
        },
        validateMin(rule, value, callback) {
            if (Number(value) < Number(format(new Date(), "YYYYMMDD"))) {
                callback(new Error("证件有效期必须大于当前日期，请重新选择"));
            } else {
                callback();
            }
        },
        validatePostCode2(rule, value, callback) {
            this.$util.validatePostCode(rule, value, callback);
        },

        validateSelectedOptions(rule, value, callback) {
            if (value && value.length >= 1) {
                callback();
            } else {
                callback(new Error("请选择省市县"));
            }
        },
        validateLivingaddress(rule, value, callback) {
            if (!value) {
                callback(new Error("请输入详细地址"));
            } else {
                callback();
            }
        },
        /* 返回上一页页 */
        backPage() {
            this.$emit("get-acct", false);
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo() {
            const _this = this;
            // this.$util.highriskareaquery(this.acctInfo.cncountry,this.acctInfo.cnprovince,res => {
            //     if(res == "1") {
            //         this.$alert("尊敬的客户您好，您的受益人所在的国籍为反洗钱法规确认的高危地区，请联系客服进行修改操作！");
            //         return;
            //     }
            // })
            if (
                ((this.acctInfo.deliverway === "2" || this.acctInfo.deliverway === "5") &&
                    this.acctInfo.faxcycode === "86" &&
                    this.acctInfo.faxareacode === "") ||
                (this.acctInfo.benefisself === "0" &&
                    this.acctInfo.beneficiarytelnocycode === "86" &&
                    this.acctInfo.beneficiarytelnoareacode === "") ||
                (this.acctInfo.actualisself === "0" &&
                    this.acctInfo.actualctrltelnocycode === "86" &&
                    this.acctInfo.actualctrltelnoareacode === "") ||
                (this.acctInfo.telno === "86" && this.acctInfo.telnoareacode === "")
            ) {
                this.$alert("请选择地区码！");
                return;
            }
            _this.setLivingAddr();
            _this.setActualAddress();
            _this.setBenefAddress();
            if (!this.checkAddressInfo() || !this.checkBenefActualInfo()) {
                return;
            }
            this.$refs.acctInfo.validate((valid, obj) => {
                if (valid) {
                    this.protocol = true;
                } else {
                    return false;
                }
            });
        },
        /* gotoSub(){
            this.dialogVisible = false;
            this.protocol = true;
        }, */
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        // 生成搜索列表
        querySearch(queryString, cb) {
            let cityObj = this.city.find((item) => {
                return item.cityid === this.acctInfo.city;
            });
            this.acctInfo.cityName = cityObj.cityname;
            this.$util.querySearch(this, queryString, this.data.bankid, cb);
        },
        checkBankName() {
            const _y = this.branchList.filter((branch) => {
                return branch.branchname === this.acctInfo.bankname;
            });
            if (_y.length === 0) {
                this.$set(this.acctInfo, "bankname", "");
            }
        },
        querySearchEmail(queryString, callback) {
            let confirmSuffix = "";
            if (
                queryString.indexOf("@") > -1 &&
                queryString.substring(queryString.indexOf("@")).length > 1
            ) {
                let suffix = queryString.substring(queryString.indexOf("@"));
                let emailSuffix =
                    this.$cache.getEmailSuffix() || this.$util.getConfig().defaultEmailSuffix;
                let delimiter = ",";
                if (emailSuffix.indexOf("，") > -1) {
                    delimiter = "，";
                }

                emailSuffix.split(delimiter).forEach((item) => {
                    if (item.indexOf(suffix) > -1) {
                        confirmSuffix += item + ",";
                    }
                });
                confirmSuffix = confirmSuffix.substring(0, confirmSuffix.length - 1);
                queryString = queryString.substring(0, queryString.indexOf("@"));
            } else if (queryString.indexOf("@") > -1) {
                queryString = queryString.substring(0, queryString.indexOf("@"));
            }
            let emailSuffix = this.getEmailSuffix(confirmSuffix);
            let results = Object.assign([], emailSuffix);
            for (let item in results) {
                results[item].value = queryString + "" + emailSuffix[item].value;
            }
            callback(results);
        },
        getEmailSuffix(suffix) {
            let emailSuffix =
                suffix || this.$cache.getEmailSuffix() || this.$util.getConfig().defaultEmailSuffix;
            let delimiter = ",";
            if (emailSuffix.indexOf("，") > -1) {
                delimiter = "，";
            }
            return emailSuffix.split(delimiter).map((item) => {
                return { value: item };
            });
        },
        // 受益人证件有效期
        beneficiaryDateInterval(val) {
            this.acctInfo.beneficiarydate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("beneficiarydate");
        },
        // 控制人证件有效期
        actualctrlDateInterval(val) {
            this.acctInfo.actualctrlvalidate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        // dateInterval (val) {
        //     this.acctInfo.beneficiarydate = val !== null ? val.replace(/-/g, "") : "";
        //     this.$refs.acctInfo.validateField("beneficiarydate");
        // },
        specificnaturalper(fn) {
            var _this = this;
            var _param = {
                invtp: "1",
                certificatetype: this.acctInfo.certificatetype,
                custfullname: this.acctInfo.custname,
                action: "Q"
            };
            this.$util.specificnaturalper(_param, (res) => {
                if (res != null) {
                    if (_this.acctInfo.natural == "0") {
                        fn();
                    }
                }
            });
        },
        validateDeliverway(rule, value, callback) {
            if (
                !this.$util.isEmpty(this.acctInfo.delivertype) &&
                this.acctInfo.delivertype !== "1" &&
                this.$util.isEmpty(value)
            ) {
                callback(new Error("请选择对账单寄送方式"));
            } else {
                callback();
            }
        },
        dealValid_benefit(val) {
            this.acctinfo.benefitvalidtype = val ? "1" : "";
        },
        dealValid_actual(val) {
            this.acctinfo.actualctrlvalitype = val ? "1" : "";
        },
        getDeliverway(val) {
            // let string =  val instanceof Array  ? val.join(",") : ''
        }
    }
};
</script>
<style lang="scss">
.comp-open-acct {
    .open-box {
        .el-form-item {
            &.is-required .el-form-item__label:before {
                display: inline;
                content: "";
            }
            &.required .el-form-item__label:before {
                display: inline;
                content: "*";
                color: $color-c;
                margin-right: 2px;
            }
        }
    }
    .el-button.info-btn {
        border: none;
        padding: 10px;
        &:hover,
        &:focus {
            background-color: transparent;
        }
    }
}
.pwd-text {
    margin-bottom: 0px;
    color: $text-color3;
    .el-form-item__content {
        line-height: 24px;
        .info {
            margin: -16px 0 16px 0;
        }
    }
}
</style>
